import { GKEditor, Grid2, Typography } from "components";
import { Controller, useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";

const TermsConditionsForm = () => {
  const form = useFormContext<WebsiteDetails>();

  return (
    <Grid2 container spacing={4} p={2}>
      <Grid2 size={12}>
        <Typography fontSize={14} fontWeight={700} color="var(neutral-900)">
          Terms & Conditions
        </Typography>
      </Grid2>

      <Grid2
        size={12}
        sx={{
          "& .ck.ck-content.ck-editor__editable": {
            maxHeight: "580px",
            overflow: "auto",
          },
        }}
      >
        <Controller
          name="compliance.termsConditions"
          control={form.control}
          render={({ field, fieldState: { error } }) => (
            <GKEditor
              {...field}
              error={!!error}
              helperText={error?.message}
              toolbar={[
                "undo",
                "redo",
                "|",
                "heading",
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "blockQuote",
                "|",
                "fontSize",
                "fontColor",
                "fontBackgroundColor",
                "|",
                "alignment",
                "subscript",
                "superscript",
                "|",
                "bulletedList",
                "numberedList",
              ]}
            />
          )}
        />
      </Grid2>
    </Grid2>
  );
};

export default TermsConditionsForm;
